import { get } from 'lodash'

export default class MainForm {
  #fieldGetter
  #fieldPathMap

  constructor(fieldGetter, fieldPathMap) {
    this.#fieldGetter = fieldGetter
    this.#fieldPathMap = fieldPathMap
  }

  field(name, property = 'value') {
    const fieldPath = get(this.#fieldPathMap, ['MAIN_FORM', name])
    const field = this.#fieldGetter(fieldPath)

    return get(field, property)
  }
}
